import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { cn } from '@/lib/utils';
import { FristenContextProvider } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/context/FristenContextProvider';

export function Content() {
  const { ctx } = useAnlageassistentContext();
  const form = useAnlageassistentFormContext();
  const currentStep = ctx.state.steps[ctx.state.currentStepIndex];
  const currentSubStep =
    currentStep.type === 'step'
      ? currentStep.subSteps[ctx.state.currentSubStepIndex]
      : null;
  return (
    <FristenContextProvider>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          form.handleSubmit();
        }}
        className={cn(
          'w-full h-full overflow-y-auto md:overflow-y-visible p-4 md:p-0',
          currentStep.type === 'step' && 'md:mt-10',
        )}>
        {currentStep.type === 'summary' && currentStep.content}
        {currentStep.type === 'step' && currentSubStep?.content}
      </form>
    </FristenContextProvider>
  );
}
